import { getStoreApiUrl } from "../helpers/api";
function setAxiosHeaders(response) {
  if (response.headers) {
    $nuxt.$axios.defaults.headers = response.headers;
  } else {
    $nuxt.$axios.defaults.headers["access-token"] =
      $nuxt.$ls.get("v2-access-token");
    $nuxt.$axios.defaults.headers["client"] = $nuxt.$ls.get("v2-client");
    $nuxt.$axios.defaults.headers["expiry"] = $nuxt.$ls.get("v2-expiry");
    $nuxt.$axios.defaults.headers["token-type"] =
      $nuxt.$ls.get("v2-token-type");
    $nuxt.$axios.defaults.headers["uid"] = $nuxt.$ls.get("v2-uid");
  }
  $nuxt.$axios.defaults.headers["platform"] = "web";
}

function getV1LocalStorageFormat(val) {
  return JSON.stringify({ value: val, expire: null });
}

function setLocalStorageVariables(response) {
  //// V1 LS
  $nuxt.$ls.set(
    "access-token",
    getV1LocalStorageFormat(response.headers["access-token"])
  );
  $nuxt.$ls.set("client", getV1LocalStorageFormat(response.headers["client"]));
  $nuxt.$ls.set("expiry", getV1LocalStorageFormat(response.headers.expiry));
  $nuxt.$ls.set(
    "token-type",
    getV1LocalStorageFormat(response.headers["token-type"])
  );
  $nuxt.$ls.set("uid", getV1LocalStorageFormat(response.headers.uid));
  $nuxt.$ls.set("vPending", getV1LocalStorageFormat(true));
  $nuxt.$ls.set("isLoggedIn", getV1LocalStorageFormat(true));
  $nuxt.$ls.set("name", getV1LocalStorageFormat(response.data?.name));
  $nuxt.$ls.set("mobile", getV1LocalStorageFormat(response.data.mobile_number));
  $nuxt.$ls.set("user_id", getV1LocalStorageFormat(response.data.id));
  $nuxt.$ls.set("beta_user", getV1LocalStorageFormat(response.data.beta_user));
  $nuxt.$ls.set(
    "avatar_url",
    getV1LocalStorageFormat(response.data.avatar_url)
  );
  $nuxt.$ls.set(
    "url",
    getV1LocalStorageFormat($nuxt.$axios.defaults.baseURL.slice(0, -1))
  );
  $nuxt.$ls.set("activeRole", getV1LocalStorageFormat("initiator"));

  // V2 LS
  $nuxt.$ls.set("v2-access-token", response.headers["access-token"]);
  $nuxt.$ls.set("v2-client", response.headers["client"]);
  $nuxt.$ls.set("v2-expiry", response.headers.expiry);
  $nuxt.$ls.set("v2-token-type", response.headers["token-type"]);
  $nuxt.$ls.set("v2-uid", response.headers.uid);
  $nuxt.$ls.set(
    "business-id",
    getV1LocalStorageFormat(response.data.business?.id)
  );
  if (response.data.business?.locations?.length) {
    $nuxt.$ls.set(
      "selected-location-id",
      response.data.business.locations[0].id
    );
  }
  if (
    !$nuxt.$ls.get("selected-restaurant-id") &&
    response.data.restaurants &&
    response.data.restaurants.length
  ) {
    $nuxt.$ls.set(
      "selected-restaurant-id",
      response.data.restaurants[0].restaurant_id
    );
  }

  // var ct = CryptoJS.AES.encrypt(
  //   response.headers.get("access-token"),
  //   "response.headers.get('access-token')"
  // );
  // Vue.ls.set("atn", ct.toString());
  // //Vue.ls.set('access-token', response.headers.get('access-token'))
  // Vue.ls.set("client", response.headers.get("client"));
  // Vue.ls.set("expiry", response.headers.get("expiry"));
  // Vue.ls.set("token-type", response.headers.get("token-type"));
  // Vue.ls.set("uid", response.headers.get("uid"));
  // Vue.ls.set("vPending", true);
  // Vue.ls.set("isLoggedIn", true);
  // Vue.ls.set("name", this.username);
  // Vue.ls.set("mobile", "+" + this.countrycode.phonecode + this.mobile);
  // Vue.ls.set("user_id", response.data.data.id);

  // var bifrostCors = new bifrostCors($nuxt.$config.V1_BASE_URL, false);
  // bifrostCors.setLocalStorage({ key: "user", value: "user-1" });
}

function removeLocalStorageVariables() {
  // localStorage.clear();
  $nuxt.$ls.remove("access-token");
  $nuxt.$ls.remove("client");
  $nuxt.$ls.remove("expiry");
  $nuxt.$ls.remove("token-type");
  $nuxt.$ls.remove("uid");
  $nuxt.$ls.remove("vPending");
  $nuxt.$ls.remove("isLoggedIn");
  $nuxt.$ls.remove("name");
  $nuxt.$ls.remove("mobile");
  $nuxt.$ls.remove("user_id");
  $nuxt.$ls.remove("beta_user");
  $nuxt.$ls.remove("avatar_url");
  $nuxt.$ls.remove("url");
  $nuxt.$ls.remove("activeRole");
  $nuxt.$ls.remove("v2-access-token");
  $nuxt.$ls.remove("v2-client");
  $nuxt.$ls.remove("v2-expiry");
  $nuxt.$ls.remove("v2-token-type");
  $nuxt.$ls.remove("v2-uid");
  $nuxt.$ls.remove("business-id");
  $nuxt.$ls.remove("selected-location-id");
  $nuxt.$ls.remove("selected-restaurant-id");
}

async function postProfileActions({ response, commit }) {
  setLocalStorageVariables(response);
  setAxiosHeaders(response);
  // window.mixpanel?.identify(response.data?.id);
  commit("SET_HEADERS", response.headers);
  commit("SET_USER", response.data);
  if (!response.data.beta_user) {
    window.location.replace(`${$nuxt.$config?.public?.V1_BASE_URL}manage-menu`);
  } else if (!response.data.business?.id) {
    $nuxt.$router.push({
      name: "restaurant-create-restaurant"
    });
  } else {
    commit("restaurant/SET_BUSINESS_DETAILS", response.data.business, {
      root: true
    });
    await $nuxt.$store.dispatch("restaurant/getLocationDetails");
  }
}
export const state = () => ({
  user: {},
  headers: {},
  users: [],
  userInfoLoading: false
});

export const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_HEADERS(state, headers) {
    state.headers = headers;
  },
  SET_USER_INFO_LOADING(state, userInfoLoading) {
    state.userInfoLoading = userInfoLoading;
  }
};

export const actions = {
  login({ dispatch, commit }, payload) {
    // commit("SET_USER_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .post("auth/sign_in", payload)
        .then(async function (response) {
          postProfileActions({ response, commit });
          if (
            response.data.business?.locations &&
            response.data.business?.locations.length
          ) {
            await $nuxt.$store.dispatch("restaurant/getLocationDetails");
            if ($nuxt.isAndroid() && Android.initFirebase)
              Android.initFirebase();
          }
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          // commit("SET_USER_INFO_LOADING", false);
        });
    });
  },

  signup({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post("auth", payload)
        .then(function (response) {
          // setLocalStorageVariables(response);
          setAxiosHeaders(response);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  verifySignupMobileOtp({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post("auth/confirm_mobile_otp", payload)
        .then(function (response) {
          setLocalStorageVariables(response);
          setAxiosHeaders(response);
          commit("SET_USER", response.data.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  verifySignupEmailOtp({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post("auth/confirm_email_otp", payload)
        .then(function (response) {
          setLocalStorageVariables(response);
          setAxiosHeaders(response);
          commit("SET_USER", response.data.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  requestSignupMobileOtp({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post("auth/request-otp", payload)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  requestSignupEmailOtp({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post("auth/request_email_otp", payload)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  profile({ dispatch, commit, rootState }, payload) {
    console.log(rootState);
    const uid = $nuxt.$ls.get("v2-uid");
    setAxiosHeaders({});
    commit("SET_USER_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/profile?uid=${uid}`)
        .then(async function (response) {
          postProfileActions({ response, commit });
          resolve(response);
        })
        .catch((err) => {
          dispatch("logout");
          reject(err);
        })
        .finally(() => {
          commit("SET_USER_INFO_LOADING", false);
        });
    });
  },

  logout({ dispatch, commit, rootState }) {
    commit("SET_USER_INFO_LOADING", true);
    let payload = { device_id: $nuxt.$ls.get("device_id") };
    return new Promise((resolve, reject) => {
      this.$axios
        .delete(`/auth/sign_out`, { data: payload })
        .then(async function (response) {
          removeLocalStorageVariables();
          $nuxt.$emit("disconnect-socket");
          commit("SET_HEADERS", {});
          commit("SET_USER", {});
          $nuxt.$store.commit("restaurant/SET_LOCATION_DETAILS", {});
          $nuxt.$store.dispatch("menu/resetMenuBulkUploadStore");
          // window.mixpanel?.reset();
          if ($nuxt.isAndroid() && Android.destroyFirebase) {
            Android.destroyFirebase();
            try {
              await dispatch("deleteDevice", {
                firebase_user_id: $nuxt.$ls.get("firebase_user_id"),
                device_id: $nuxt.$ls.get("device_id")
              });
            } catch (error) {
              $nuxt.$emit("show-error-toast", error);
            }
          }
          $nuxt.$router.push("/login-signup");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit("SET_USER_INFO_LOADING", false);
        });
    });
  },
  requestForgotPasswordpOtp({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post("auth/password", payload)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  verifyForgotPasswordOtp({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          "auth/passwords/verify_otp",
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  resetPassword({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .patch("auth/password", payload)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateProfileBasicDetails({ dispatch, state }, payload) {
    const uid = state.user.id;
    return new Promise((resolve, reject) => {
      this.$axios
        .put(`users/${uid}`, payload)
        .then(async function (response) {
          await dispatch("profile");
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  changePassword({ state }, payload) {
    const uid = state.user.id;
    return new Promise((resolve, reject) => {
      this.$axios
        .put(`auth/password`, payload)
        .then(async function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  registerDevice({ state }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`/firebase_devices`, payload)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteDevice({}, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`/firebase_devices/delete_devices`, payload)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

export const getters = {
  userInfoLoading(state) {
    return state.userInfoLoading;
  },
  isLoggedIn(state) {
    return !!state.user.id;
  }
};
